module.exports = "mutation ($id: ID!) {\n  ResidentialTemplateDelete(id: $id) {\n    id\n  }\n}\n"